<template>
	<div class='page'>
		<pageTitle title='我要点评' @rightHandler='publish' :showRight='true' rightTitle='发布' />
		<div class='hotelMsg whiteBg'>
			<img src='../../../static/search/noImg.jpg' />
			<div class='right'>
				<div class='name'>{{comment.HotelName}}</div>
				<div class='address'>
					<mu-icon value="room" color="#A5A5A5" :size='13' />
					{{comment.Address}}
				</div>
				<div class='desc'>入住：{{comment.CheckInTime}}</div>
				<div class='desc'>离店：{{comment.CheckOutTime}}</div>
				<div class='desc'>房型：{{comment.RoomType}}</div>
			</div>
		</div>
		<div class='greyBg greyBlock'>
		</div>
		<div class='main'>
			<div class='title'>请您评价本次入住，点评、追评字数大于15字将获取30K币</div>
			<div class='feel'>
				{{scoreDisplay}}
			</div>
			<div class='score'>
				<stars @select='changeScore' :score='score' :canChoose='true'/>
			</div>
			<div class='tagGroup'>
				<span @click='changeLabel(label)' v-bind:class="{'active': label.Selected}"  v-for='label in labelList[score - 1]' class='tag'>{{label.LabelName}}</span>
			</div>
			<div class='text'>
				<inputArea v-model='content' height='2.15rem' hitMsg='分享您对酒店环境、服务、设施和价格等的感受' />
			</div>
			<mu-toast v-if="toast" id="alertline" v-bind:message="hintMsg" @close="hideToast" />
		</div>
	</div>
</template>

<style lang="less" scoped>
@import '../../assets/theme.less';
@import '../../assets/tag.less';

	.hotelMsg{
		display:flex;
		padding:0.3rem;
		img{
			max-width:1.22rem;
			height:0.9rem;
			margin-right:0.3rem;
		}
		.right{
			.name{
				color:#333333;
				font-size:0.28rem;
			}
			.address{
				font-size:0.22rem;
				i{
					position:relative;
					top:1px;
					left:-1px;
				}
				margin-bottom:0.1rem;
			}
			.desc{
				font-size:0.22rem;
				line-height:0.36rem;
			}
		}
	}
	.greyBlock{
		height:0.2rem;
	}
	.main{
		padding-bottom:0.5rem;
		.title{
			text-align:center;
			width: 5rem;
			margin: 0 auto;
			font-size:0.24rem;
			padding-top:0.46rem;
			padding-bottom:0.78rem;
		}
		.feel{
			text-align:center;
			font-size:0.46rem;
			color:@darkOrange;
		}
		.score{
			text-align:center;
			font-size:0.46rem;
		}
		.tagGroup{
			margin-top:0.78rem;
		}
		.text{
			margin-top:0.5rem;
			padding:0.3rem;
		}
	}
</style>

<script>
	import pageTitle  from '../../components/pageTitle.vue'
	import stars from '../../components/stars'
	import inputArea from '../../components/input/inputArea.vue'
	import api from '../../api/index.js'
	import hotelService from '../../utils/hotelService.js'
	import { mapGetters, mapMutations } from 'vuex'

	export default {
		data () {
			return {
				comment:'',
				score: 5,
				content:'',
				labelList:[[],[],[],[],[]],
				activeLabel:1,
				hintMsg: '',
      	toast: false
			}
		},
		components: {
			pageTitle,stars,inputArea
		},
		methods: {
			changeScore(val){
        if(val !== this.score){
          this.score = val
          this.GetLabelList()
        }
			},
			GetLabelList(){
				var index = this.score - 1
				var params = new this.URLSearchParam();
     	 	params.append('score', this.score);
				this.$http.post(api.GetHotelCommentLabelByScore(), params.toParam()).then((res) => {
					if(res.Result){
						var temp = res.Data
						temp.forEach(function(element) {
							element.Selected = false
						}, this);
						if(temp.length > 0){
							temp[0].Selected = true
						}
						this.labelList.splice(index, 1, temp)
					}
				})
			},
			changeLabel(label){
				label.Selected = !label.Selected
			},
			//插入酒店评论
			InsertHotelTopic(){
				var params = new this.URLSearchParam()
				params.append('hotelCode', this.comment.HotelCode)
				params.append('CommentContent', this.content)
				params.append('labelId', this.getSelectedLabel())
				//这里传订单号
				params.append('anonCode', this.comment.OrderId)
				//房间编号
				params.append('roomId', this.comment.RoomId)
				//房间名
				params.append('roomName', this.comment.RoomType)
				params.append('point', this.score)
				params.append('cardNo',this.$route.query.cardNo)
				this.$http.post(api.InsertHotelTopic(), params.toParam()).then((res) => {
					this.showToast(res.Message)
					var that = this
					setTimeout(function() {
						that.$router.go(-1)
					}, 1200);
				})
			},
			publish(){
				if(this.content == ''){ 
					this.showToast('请填写评论内容')
					return 
				}
				this.InsertHotelTopic()
			},
			showToast(hintMsg) {
				if(hintMsg){
					this.hintMsg = hintMsg
				}
				this.toast = true
				if (this.toastTimer) clearTimeout(this.toastTimer)
				this.toastTimer = setTimeout(() => { this.toast = false }, 2000)
			},
			hideToast() {
				this.toast = false
				if (this.toastTimer) clearTimeout(this.toastTimer)
			},
			getSelectedLabel(){
				var result = ''
				var list = this.labelList[this.score - 1]
				list.forEach(function(element) {
					if(element.Selected){	
						result += element.LabelId + ','
					}
				}, this);
				return result
			}
		},
	  computed:{
      ...mapGetters([
        'g_currentInfo'
			]),
			scoreDisplay(){
				return hotelService.scoreDisplay(this.score)
			},
		},
		activated(){
			this.comment = this.$route.query
			this.GetLabelList()
		}
	}
</script>


// WEBPACK FOOTER //
// writeComments.vue?ff1267a2